exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n#checkoutTableDiv[data-v-1a6e370c]{\n  min-height: 300px;\n}\ntable tr[data-v-1a6e370c]{\n  line-height: 3rem;\n}\ntable tr td[data-v-1a6e370c]{\n  padding-left: 2px;\n  padding-right: 3px;\n}\n", "", {"version":3,"sources":["/codebuild/output/src663559002/src/slink-frontend/src/pages/Orders.vue"],"names":[],"mappings":";AACA;EACE,kBAAkB;CACnB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,kBAAkB;EAClB,mBAAmB;CACpB","file":"Orders.vue","sourcesContent":["\n#checkoutTableDiv[data-v-1a6e370c]{\n  min-height: 300px;\n}\ntable tr[data-v-1a6e370c]{\n  line-height: 3rem;\n}\ntable tr td[data-v-1a6e370c]{\n  padding-left: 2px;\n  padding-right: 3px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1a6e370c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Orders.vue
// module id = QfNr
// module chunks = 1